export default {
      id: "gift-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#gift",
      toString: function () {
        return this.url;
      }
    }